import styled from 'styled-components';
import { theme } from '@frameio/vapor';

// Shared - Opacity Control and Rotation Control
export const SliderContainer = styled.div`
  align-items: center;
  display: flex;
  flex: 1;
  gap: ${theme.spaces[16]};
`;
